import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';

import { NavList } from '../NavList';

const navListStyle = css`
  display: inline-block;
  width: 100%;
`;

const MobileNavList = ({ children }) => (
  <NavList className={navListStyle}>{children}</NavList>
);

MobileNavList.propTypes = {
  /**
   * Links to show in this group
   */
  children: PropTypes.node,
};

export default MobileNavList;
